<template>
    <TopBg :showBg="!$web.isDesktop">

        <h1 class="desktop-title" v-if="$web.isDesktop" v-text="contents.title"/>

        <!-- Top logo -->
        <TopLogo :white="true" v-if="!$web.isDesktop"/>

        <div class="d-flex flex-column justify-content-between h-75 pt-4 page-content"
             :class="{'desktop-card desktop-card-small':$web.isDesktop}">

            <!-- Title -->
            <div v-text="contents.title" class="title" v-if="!$web.isDesktop"/>

            <div class="text-center mb-4">
                <div v-text="contents.subtitle" class="subtitle"/>
                <div v-text="contents.content" class="content" v-if="!$web.isDesktop"/>
                <div class="content" v-else>
                    Compila il modulo qui sotto e ottieni gratuitamente una consulenza telefonica con uno dei nostri
                    esperti di gestione energetica, che ti aiuterà a capire come risparmiare da subito sui consumi di
                    luce e gas.
                </div>
            </div>

            <div class="mb-3">
                <!-- Phone label -->
                <label v-text="contents.name" for="name" class="input-label"/>

                <!-- Phone input -->
                <TextInput
                    type="text" id="name"
                    :value="message.name" @input="message.name = $event.value"/>

                <!-- Phone label -->
                <label v-text="contents.phone" for="phone" class="input-label"/>

                <!-- Phone input -->
                <TextInput
                    type="tel" id="phone"
                    :value="message.phone" @input="message.phone = $event.value"/>

            </div>

            <div>
                <!-- Send button -->
                <Btn :text="loading?contents.loading:contents.send" class="mb-3"
                     @click="sendMessage" :disabled="disabled || loading"/>
                <!-- Undo button -->
                <Btn type="secondary" :text="contents.undo" @click="back" v-if="!loading"/>
            </div>
        </div>
    </TopBg>
</template>

<script>
import contents from "../contents/recall"
import TopBg from "../components/TopBg"
import TopLogo from "../components/TopLogo"
import Btn from "../components/Btn";
import TextInput from "../components/TextInput";

export default {
    name: 'recall',
    components: {TextInput, Btn, TopBg, TopLogo},
    mounted() {
        this.$registerEvent('Pagina', '9. Visualizzazione Recall');
    },
    data() {
        return {
            message: {
                name: '',
                phone: '',
                source: 'webapp',
                get content() {
                    return `Richiesta di ricontatto telefonico al ${this.phone}.`
                }
            },
            loading: false,
            contents
        };
    },
    methods: {
        async sendMessage() {
            this.loading = true;
            try {
                await this.$api.postMessage(this.message);
            } catch (e) {
                if (e.response && e.response.status === 422) {
                    this.$alert(this.contents.validation_error);
                    return;
                }
                throw e;
            } finally {
                this.loading = false;
            }
            this.$registerEvent('Azione', 'Inviata richiesta recall');
            this.$registerConversion();
            this.$registerFacebookEvent('Lead')
            this.$alert(this.contents.success);
            this.$router.back();
        },
        back() {
            this.$router.back();
        }
    },
    computed: {
        disabled() {
            return !this.message.name.trim() || !this.message.phone.trim();
        }
    }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';

.page-content {
    max-height: 600px;
}

.title {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: $darkGrey;
    padding: 0 40px;
    margin: 0 0 20px;
}

.subtitle {
    margin-bottom: 10px;
    color: #f9620a;
    font-weight: 800;
    font-size: 22px;
}

.content {
    color: #747474;
    font-size: 17px;
}

.input-label {
    font-family: "Poppins";
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    display: block;
    color: $darkGrey;
}
</style>

